import Vue from 'vue';

export default {
  namespaced: true,

  // initial state
  state: {
    item: {
      user: {
        type: 1,
      },
      data: {
        status: 0,
      },
    },
  },

  // getters
  getters: {
    getItem(state) {
      return state.item;
    },
  },

  // actions
  actions: {
    loadItem({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/event`, { params: params })
          .then((response) => {
            commit('setItem', response.data);
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    updateEvent({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set("event_id", JSON.stringify(params.event_id));
        data.set("fields", JSON.stringify(params.fields));
        data.set("values", JSON.stringify(params.values));

        Vue.axios.put(`/event`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    sendNotification({}, params) {
      return new Promise((resolve, reject) => {
        let data = new FormData();

        data.set("event_id", JSON.stringify(params.event_id));

        Vue.axios.post(`/notify`, data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },

  // mutations
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
  },
};
